
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"20.711"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M9.893 0a5.787 5.787 0 013.6 2.706A5.1 5.1 0 117.374.295c.252-.086.492-.2.732-.3zM9.001 20.707c-2.116 0-4.231.01-6.341 0-1.82-.01-2.767-.861-2.651-2.355.271-3.5 3.358-6.215 7.749-6.827 3.807-.528 8 1.359 9.52 4.382a7.807 7.807 0 01.707 2.664c.148 1.26-.9 2.116-2.466 2.131-2.17.018-4.347.005-6.518.005z"}})])
          )
        }
      }
    